var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12C20.96 12 12 20.96 12 32C12 43.04 20.96 52 32 52C43.04 52 52 43.04 52 32C52 20.96 43.04 12 32 12ZM34 46H30V42H34V46ZM38.14 30.5L36.34 32.34C35.34 33.36 34.62 34.28 34.26 35.72C34.1 36.36 34 37.08 34 38H30V37C30 36.08 30.16 35.2 30.44 34.38C30.84 33.22 31.5 32.18 32.34 31.34L34.82 28.82C35.74 27.94 36.18 26.62 35.92 25.22C35.66 23.78 34.54 22.56 33.14 22.16C30.92 21.54 28.86 22.8 28.2 24.7C27.96 25.44 27.34 26 26.56 26H25.96C24.8 26 24 24.88 24.32 23.76C25.18 20.82 27.68 18.58 30.78 18.1C33.82 17.62 36.72 19.2 38.52 21.7C40.88 24.96 40.18 28.46 38.14 30.5Z",
    fill: "#0C2340"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#0C2340",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistance);
export default __webpack_public_path__ + "static/media/assistance.249c8cf183b53ec20748263c690515d5.svg";
export { ForwardRef as ReactComponent };